import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager, printMissingConfigError, SiteConfigManager } from '@atlas/core';
import { BasePopup, Button } from '@atlas/ui';

import StaticBlock from 'common/StaticBlock/StaticBlock';
import history from 'components/Layout/history';

const ResponsibleGamingPopup = ({ data: { onClose = () => {} } = {}, id }) => {
  const block = SiteConfigManager.getConfig(
    'config.config.responsible_gaming.popup_static_block_name',
  );

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
    onClose();
  }, [id, onClose]);

  const moreHandler = useCallback(() => {
    history.push('/account/responsible-gaming/self-regulation');
    handleClose();
  }, [handleClose]);

  if (!block) {
    printMissingConfigError('config.config.responsible_gaming.popup_static_block_name');
  }

  return (
    <BasePopup onClose={handleClose} title="responsible_gaming">
      <div className="popup__content">
        <StaticBlock options={{ source: block }} />
      </div>

      <div className="popup__footer">
        <div className="popup__buttons">
          <Button className="secondary big block" label="close" onClick={handleClose} />

          <Button className="primary big block" label="more" onClick={moreHandler} />
        </div>
      </div>
    </BasePopup>
  );
};

ResponsibleGamingPopup.propTypes = {
  data: PropTypes.shape({
    onClose: PropTypes.func,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ResponsibleGamingPopup;
